export const LayoutStyles = {
  maxWidth: '800px',
  verticalPadding: '25px',
  horizontalPadding: '45px',
};
